module.exports = __webpack_public_path__ + "static/img/qrcode-app.21b26010.png";